import { put, call, takeLatest } from 'redux-saga/effects';
import { getUserPreviousOrders } from '~/common/redux/api';
import { GA_OPTIONS } from '~/common/utils/constants';
import * as actions from '../actions';
import { GET_USER_PREVIOUS_ORDERS_REQUEST } from '../types';
import { pushGAInteraction } from '../../../shared/utils/gaTags';

export function* getUserPreviousOrdersSaga({ payload: { onSuccess, onError } }) {
  const { ACCOUNT, DASHBOARD, PREVIOUSLY_OWNED_CARD } = GA_OPTIONS;
  try {
    yield put(actions.addLoader(GET_USER_PREVIOUS_ORDERS_REQUEST));
    const {
      data: { data: hasPreviousOrders },
    } = yield call(getUserPreviousOrders);
    onSuccess(hasPreviousOrders);
    if (hasPreviousOrders) {
      pushGAInteraction({
        event: ACCOUNT,
        interaction: PREVIOUSLY_OWNED_CARD,
        label: DASHBOARD,
      });
    }
  } catch (e) {
    onError();
  }
  yield put(actions.removeLoader(GET_USER_PREVIOUS_ORDERS_REQUEST));
}

const previousOrdersSaga = [
  takeLatest(GET_USER_PREVIOUS_ORDERS_REQUEST, getUserPreviousOrdersSaga),
];

export default previousOrdersSaga;
